import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

function NotificationDialog(props: {
  openDialog: any;
  handleDialogClose: any;
  currentAlert: any;
  markAsRead?: any;
  isDispalyMarkAs: any;
  loading: any;
}) {
  const {
    openDialog,
    handleDialogClose,
    currentAlert,
    markAsRead,
    loading,
    isDispalyMarkAs,
  } = props;
  return (
    <>
      <Dialog
        open={openDialog}
        fullWidth
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {currentAlert?.message || 'Notification Details'}
        </DialogTitle>
        <DialogContent>
          <div
            id="alert-dialog-description"
            dangerouslySetInnerHTML={{
              __html: currentAlert?.messageDescription || '',
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          {isDispalyMarkAs && (
            <Button
              onClick={() => markAsRead(currentAlert?.id)}
              color="primary"
              variant="contained"
              disabled={loading}
            >
              {loading ? 'loading...' : 'Mark as Read'}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}

export default NotificationDialog;
